import React from 'react';
import { Card } from 'react-bootstrap';

const THEME = {
  green: {
    border: '#7AE3A1',
    bg: '#F0FDF4',
    label: '#00A63D',
  },
  blue: {
    border: '#B7D7FF',
    bg: '#EFF6FF',
    label: '#1447e6',
  },
  amber: {
    border: '#FCD34D',
    bg: '#FFFBEB',
    label: '#B45309',
  },
  red: {
    border: '#FCA5A5',
    bg: '#FEF2F2',
    label: '#B91C1C',
  },
  purple: {
    border: '#D7CCFF',
    bg: '#F5F3FF',
    label: '#7008DC',
  },
  yellow: {
    border: '#E8D9A8',
    bg: '#F5EEDC',
    label: '#D97706',
  },
};

const KpiCard = ({
  title,
  value,
  unit,
  variant = 'green',
  level = 'primary', // primary | secondary
}) => {
  const isPrimary = level === 'primary';
  const theme = THEME[variant] || THEME.green;

  return (
    <Card
      style={{
        border: isPrimary
          ? `1px solid ${theme.border}`
          : '1px solid #E5E7EB',
        backgroundColor: isPrimary
          ? theme.bg
          : '#F8FAFC', // ✅ yêu cầu của bạn
        borderRadius: 12,
      }}
    >
      <Card.Body
        style={{
          padding: isPrimary ? 20 : 16,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {/* TITLE */}
        <div
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: isPrimary ? theme.label : '#313131',
            marginBottom: 6,
          }}
        >
          {title}
        </div>

        {/* VALUE */}
        <div
          style={{
            fontSize: isPrimary ? 34 : 21,
            fontWeight: isPrimary ? 700 : 500,
            color: isPrimary ? '#000000' : '#313131',
            lineHeight: 1.1,
          }}
        >
          {value}
        </div>

        {/* UNIT */}
        <div
          style={{
            fontSize: 13,
            marginTop: 6,
            color: isPrimary ? theme.label : '#313131',
          }}
        >
          {unit}
        </div>
      </Card.Body>
    </Card>
  );
};

export default KpiCard;
